module.exports = __webpack_public_path__ + "img/logo.45b78a27.png";